var equalColumnHeightPlugin = require('./../../shared/scripts/equalizeColumnHeights');
var scrollToElement = require('./../../shared/scripts/scrollToElement');
var { getUrlParameterByName } = require('./../../shared/scripts/UrlParameterHelper');
var Timer = require('./../../shared/components/countdowntimer/countdowntimer');

$(function () {
    //Draw game detail
   // if (!$('.draw-game-detail-container').length) return;

    let durationInSeconds = $('#draw-game-countdown-timer-seconds-remaining').val();
    if (durationInSeconds) {
        let $timer = new Timer("draw-game-countdown-timer", durationInSeconds);
        $timer.start();
    }

    let $drawGameTabs = $('.nav-tabs').eq(0);    
    setInitialPageScrollFromUrl($drawGameTabs);  

    //Draw game detail promos
    if (!$('.draw-game-detail-promo-container').length) return;
    $('.draw-game-detail-promo-container .equal-height').equalizeColumnHeights();
});

function setInitialPageScrollFromUrl($drawGameTabs) {
    var qsScrollTo = getUrlParameterByName('scrollto', window.location.search);
    if (!qsScrollTo) return;
    let windowWidth = window.screen.width < window.outerWidth ? window.screen.width : window.outerWidth;
    let mobile = windowWidth < 500; 
    switch (qsScrollTo.toUpperCase()) {
        case "PASTNUMBERS":
            scrollToElement({ scrollToThis: `.tabs-container` });            
            //Try to open the Past Numbers tab.. if the tab order changes in sitecore it will scroll but wont automatically open the tab
            if(mobile){ 
                if($('#heading-38a0459f-be0e-421d-b7ca-2a14f8732457').length){
                    triggerclick($('#heading-38a0459f-be0e-421d-b7ca-2a14f8732457 h4'));
                }
                if($('#heading-2fefb351-031a-474d-81f4-f8eda5014af1').length){
                    triggerclick($('#heading-2fefb351-031a-474d-81f4-f8eda5014af1 h4'));
                }
                if($('#heading-9fd83e9d-169c-4e18-83ab-79973bc978b4').length){
                    triggerclick($('#heading-9fd83e9d-169c-4e18-83ab-79973bc978b4 h4'));
                }
                if($('#heading-aae7b972-7ba3-48a6-8815-430b20bb2896').length){
                    triggerclick($('#heading-aae7b972-7ba3-48a6-8815-430b20bb2896 h4'));
                } 
                if($('#heading-bf9e3900-9e52-495a-ac95-e2b4b7f89fa1').length){
                    triggerclick($('#heading-bf9e3900-9e52-495a-ac95-e2b4b7f89fa1 h4'));
                }
                if($('#heading-78c9d4d5-8b47-4bf9-ba2e-744c7c327cdc').length){
                    triggerclick($('#heading-78c9d4d5-8b47-4bf9-ba2e-744c7c327cdc h4'));
                }
                if($('#heading-e07bdf17-a7d6-470e-b6b4-af16bbf3427c').length){
                    triggerclick($('#heading-e07bdf17-a7d6-470e-b6b4-af16bbf3427c h4'));
                }                           
            }else{
                $drawGameTabs.find('h4:last').tab('show');
            }
            break;
        case "PRIZES":
            scrollToElement({ scrollToThis: `.tabs-container` });
            if(mobile){
                if($('#heading-dc9ef767-ac22-4f5d-a1cc-d6924a67741f').length){
                    triggerclick($('#heading-dc9ef767-ac22-4f5d-a1cc-d6924a67741f h4'));
                }
                if($('#heading-a783e019-10a6-4427-b3ec-513a41c8b469').length){
                    triggerclick($('#heading-a783e019-10a6-4427-b3ec-513a41c8b469 h4'));
                }
                if($('#heading-5f143379-67ad-462f-aadb-67b6f62ab39d').length){
                    triggerclick($('#heading-5f143379-67ad-462f-aadb-67b6f62ab39d h4'));
                }
                if($('#heading-ed271c4d-e616-441a-b408-36530c2652bb').length){
                    triggerclick($('#heading-ed271c4d-e616-441a-b408-36530c2652bb h4'));
                }
                if($('#heading-5b00eb8f-25cb-4268-994e-79015324fb38').length){
                    triggerclick($('#heading-5b00eb8f-25cb-4268-994e-79015324fb38 h4'));
                }
                if($('#heading-fc5ec26e-850d-4d85-b440-88aa1f9f5476').length){
                    triggerclick($('#heading-fc5ec26e-850d-4d85-b440-88aa1f9f5476 h4'));
                }
                if($('#heading-1473dd44-55bc-4d4b-8d19-691331ac43d4').length){
                    triggerclick($('#heading-1473dd44-55bc-4d4b-8d19-691331ac43d4 h4'));
                }
            }
            else{
                $drawGameTabs.find('h4').eq(1).tab('show');
            }
            break;
            case "RULES":
                scrollToElement({ scrollToThis: `.tabs-container` });
                if(mobile){
                    if($('#heading-2461e51b-a9a2-44e7-af4f-4cfc10334b09').length){
                        triggerclick($('#heading-2461e51b-a9a2-44e7-af4f-4cfc10334b09 h4'));
                    }
                }
                else{
                    $drawGameTabs.find('h4').eq(2).tab('show');
                }
                break;
                /*adding for check my numbers tab */
            case "MEGAMILLIONS":
                scrollToElement({ scrollToThis: `.tabs-container` });
                if(mobile){
                    if($('#heading-7f2dc6ba-751d-4ff6-a848-55dc05527f2e').length){
                        triggerclick($('#heading-7f2dc6ba-751d-4ff6-a848-55dc05527f2e h4'));
                    }
                }
                else{
                    triggerclick($drawGameTabs.find('h4').eq(0).tab('show').parent());
                }
                break;
            case "POWERBALL":
                scrollToElement({ scrollToThis: `.tabs-container` });
                if(mobile){
                    if($('#heading-a47bbd0d-7a88-418d-8275-8ffceaf0735f').length){
                        triggerclick($('#heading-a47bbd0d-7a88-418d-8275-8ffceaf0735f h4'));
                    }
                }
                else{
                    triggerclick($drawGameTabs.find('h4').eq(1).tab('show').parent());
                }
                break;
            case "BANKAMILLION":
                scrollToElement({ scrollToThis: `.tabs-container` });
                if(mobile){
                    if($('#heading-044db8cf-4502-48d5-b57e-fcd38357712a').length){
                        triggerclick($('#heading-044db8cf-4502-48d5-b57e-fcd38357712a h4'));
                    }
                }
                else{
                    triggerclick($drawGameTabs.find('h4').eq(2).tab('show').parent());
                }
            break;
            case "CASH4LIFE":
                scrollToElement({ scrollToThis: `.tabs-container` });
                if(mobile){
                    if($('#heading-64a45291-d9df-4354-a702-5442f433a853').length){
                        triggerclick($('#heading-64a45291-d9df-4354-a702-5442f433a853 h4'));
                    }
                }
                else{
                    triggerclick($drawGameTabs.find('h4').eq(3).tab('show').parent());
                }
        break;
        case "CASH5":
            scrollToElement({ scrollToThis: `.tabs-container` });
            if(mobile){
                if($('#heading-7a23ccc2-875b-4120-9c90-28bf30d0542e').length){
                    triggerclick($('#heading-7a23ccc2-875b-4120-9c90-28bf30d0542e h4'));
                }
            }
            else{
                triggerclick($drawGameTabs.find('h4').eq(4).tab('show').parent());
            }
            break;
        case "PICK4":
            scrollToElement({ scrollToThis: `.tabs-container` });
            if(mobile){
                if($('#heading-738ba583-5c17-4647-bf7e-95f2e2af585d').length){
                    triggerclick($('#heading-738ba583-5c17-4647-bf7e-95f2e2af585d h4'));
                }
            }
            else{
                triggerclick($drawGameTabs.find('h4').eq(5).tab('show').parent());
            }
        break;
        case "PICK3":
            scrollToElement({ scrollToThis: `.tabs-container` });
            if(mobile){
                if($('#heading-8834f1a7-0c81-4039-8767-64601ee7c080').length){
                    triggerclick($('#heading-8834f1a7-0c81-4039-8767-64601ee7c080 h4'));
                }
            }
            else{
                triggerclick($drawGameTabs.find('h4').eq(6).tab('show').parent());
            }
        break;
        case "KENO":
            scrollToElement({ scrollToThis: `.tabs-container` });
            if(mobile){
                if($('#heading-98a54821-d161-4e76-b65c-6afd41f5ac88').length){
                   triggerclick($('#heading-98a54821-d161-4e76-b65c-6afd41f5ac88 h4'));
                }
            }
            else{                
                triggerclick($drawGameTabs.find('h4').eq(7).tab('show').parent());
            }
        break;
        default:
            break;
    }

}
function triggerclick(item)
{
    setTimeout(function(){
        item.trigger('click');
    }, 1000);
}


// WEBPACK FOOTER //
// ./features/draw-games/draw-games.js